import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Select from 'react-select';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import excluirItinerarios from '../../actions/itinerario/exclurItinerario';
import { alterouPagina } from '../../util/filtros';
import ItinerarioEncomenda from './ItinerarioEncomenda'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarRotas from '../../actions/rota/buscarRotas';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoItinerario from '../itinerario/BotoesPaginacaoItinerario';
import PaginacaoItinerario from '../itinerario/PaginacaoItinerario';
import determinaPaginaAtual from '../../actions/itinerario/determinarPaginaAtualItinerario'
import limparItinerarios from '../../actions/itinerario/limparItinerarios'
import selecionarRota from '../../actions/rota/selecionarRota';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import { inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import { inativarVendaSite } from '../../actions/itinerario/ativarOuInativarVendaSite'
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--itin-encomenda">
        <div className="vx-list-header-cell">Data/Hora saída</div>
        <div className="vx-list-header-cell">Assentos</div>
        <div className="vx-list-header-cell">Veículo</div>
        <div className="vx-list-header-cell">Rota</div>
        <div className="vx-list-header-cell">Prestador</div>
        <div className="vx-list-header-cell">Venda Site</div>
        <div className="vx-list-header-cell">Categorias</div>
        <div className="vx-list-header-cell">Status</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

export class ItinerariosEncomenda extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.state = {
            itinerarioSelecionado: null,
            textoFiltro: null,
            rotaSelecionada: null,
            dataPartidaSelecionada: null,
            motoristasSelecionados: [],
            trechosSelecionados: [],
            cidadesSelecionadas: [],
            trechosBloqueioDescontoSelecionados: [],
            codigoItinerarioChecked: null,
            exibeTipoCategoriaUnica: true
        };
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparItinerarios();
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarRotas(this.props.empresaSelecionada.id);
                this.props.buscarVeiculos(this.props.empresaSelecionada.id);
            }
            this.props.selecionarRota([]);
        }
        if (alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerarios();
        }
    }

    limparSelecionarItinerario() {
        this.props.selecionarItinerario(null);
    }

    limparCampos() {
        this.props.reset('formularioCadastroItinerario');
        this.limparMotoristasSelecionados();
        this.limparTrechosSelecionados();
        this.limparCidadesSelecionadas();
        this.handleCheckedTipoCategoriaUnica(true);
        this.props.limparVeiculoItinerarioSelecionado();
        this.props.selecionarItinerario(null);
        this.props.limparItinerarios()
    }

    exibirTabelaItinerariosEdicao() {
        if (this.props.itinerarios && this.props.itinerarios.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoItinerario}
                                           BotoesPaginacao={BotoesPaginacaoItinerario}
                                           itinerarios={this.props.itinerarios}
                                           empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela />
                        {this.exibirItinerarios()}
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">search</span>
                    <p>Nenhum itinerário disponível</p>
                </div>
            </div>
        );
    }

    exibirTabelaItinerarios() {
        if (this.props.itinerarios && this.props.itinerarios.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoTabela />
                    {this.exibirItinerarios()}
                </div>
            )
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">search</span>
                    <p>Nenhum itinerário disponível</p>
                </div>
            </div>
        );
    }

    exibirItinerarios() {
        if (this.props.itinerarios) {
            return this.props.itinerarios
                .map((itinerario, index) => <ItinerarioEncomenda key={index}
                    isEdicao={this.props.isEdicao}
                    buscarItinerarios={this.props.buscarItinerarios}
                    itinerario={itinerario}
                    indice={index}
                />)
        }
    }

    selecionarData(data) {
        this.setState({ dataPartidaSelecionada: data });
        this.props.buscarItinerarios();
    }

    selecionarRota(rota) {
        this.setState({
            dataPartidaSelecionada: null
        });
        this.props.selecionarRota(rota);
        this.setState({ trechos: this.props.rotas.filter(it => it.id === rota.value)[0].trechosDto });
        this.props.buscarItinerarios();
    }

    exibirComboRotas(event) {
        if (this.props.rotas) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma rota...'
                        options={this.props.rotas.map(elemento => (
                            {
                                label: `${elemento.prefixo ? elemento.prefixo : 'Prefixo não informado'}: ${elemento.cidadeOrigem.nome}-${elemento.cidadeOrigem.uf} -> ${elemento.cidadeDestino.nome}-${elemento.cidadeDestino.uf} / ${elemento.prestador ? elemento.prestador : 'Prestador não informado'}`,
                                value: elemento.id
                            }))}
                        onChange={value => this.selecionarRota(value)}
                        value={this.props.rotaSelecionada}
                    />
                    {event.meta.touched
                        && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }

    render() {
        return (
            <div>
                {this.props.isEdicao ? this.exibirTabelaItinerariosEdicao() : this.exibirTabelaItinerarios()}
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        itinerarios: state.itinerarios.itinerarios,
        veiculos: state.veiculos.veiculos,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        itinerarioSelecionado: state.itinerarioSelecionado,
        rotaSelecionada: state.rotaSelecionada,
        filtrosAdicionados: state.filtrosAdicionadosItinerario,

    });


export default connect(mapStateToProps,
    {
        excluirItinerarios,
        buscarRotas,
        buscarVeiculos,
        determinaPaginaAtual,
        selecionarRota,
        limparItinerarios,
        buscarTiposPreco,
        selecionarItinerario,
        inativarItinerario,
        inativarVendaSite,
        limparVeiculoItinerarioSelecionado
    })(reduxForm({
        form: 'formularioCadastroItinerario'
    })(ItinerariosEncomenda))
